import React from 'react';
import Navbar from './Navbar';
import Footer from './Footer';
import '../styles/sections.css';
import '../styles/utilities.css';

const DevHive = () => {
  const refs = {
    overview: React.useRef(null),
    features: React.useRef(null),
    technologies: React.useRef(null),
  };

  return (
    <div className="font-sans bg-white text-gray-800 min-h-screen flex flex-col">
      <Navbar refs={refs} />

      <main className="flex-grow">
        <section ref={refs.overview} className="notify-section">
          <div className="section-header">
            <h2>DEVHIVE OVERVIEW</h2>
            <div className="underline"></div>
          </div>
          <div className="notify-entry">
            <p>
              DevHive is a full-stack project collaboration platform engineered for agile teams. 
              It provides real-time messaging via Firebase, dynamic Kanban boards, sprint-based task tracking, 
              and role-based user invites to streamline project management and team collaboration.
            </p>
            <p>
              Built with Flutter (mobile), ReactJS (web), and ASP.NET (backend), integrated with MySQL, 
              and deployed on AWS for scalable performance.
            </p>
          </div>
        </section>

        <section ref={refs.features} className="notify-section">
          <div className="section-header">
            <h2>KEY FEATURES</h2>
            <div className="underline"></div>
          </div>
          <div className="notify-entry">
            <ul>
              <li>Real-time messaging via Firebase</li>
              <li>Dynamic Kanban boards for task management</li>
              <li>Sprint-based task tracking</li>
              <li>Role-based user invites and permissions</li>
              <li>Cross-platform support (mobile and web)</li>
              <li>Scalable cloud infrastructure on AWS</li>
            </ul>
          </div>
        </section>

        <section ref={refs.technologies} className="notify-section">
          <div className="section-header">
            <h2>TECHNOLOGIES</h2>
            <div className="underline"></div>
          </div>
          <div className="notify-entry">
            <ul>
              <li><strong>Frontend:</strong> ReactJS (web), Flutter (mobile)</li>
              <li><strong>Backend:</strong> ASP.NET Core</li>
              <li><strong>Database:</strong> MySQL</li>
              <li><strong>Real-time:</strong> Firebase</li>
              <li><strong>Hosting:</strong> AWS</li>
              <li><strong>Architecture:</strong> Microservices, REST APIs</li>
            </ul>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
};

export default DevHive;
